import { serviceV2 } from '@/utils/request'

const prefix = '/common/meta'

export default {
  getMetaIndustryList (params) {
    return serviceV2.get(`${prefix}/industry/`, { params })
  },
  getMetaJobFunctionList (params) {
    return serviceV2.get(`${prefix}/job-function/`, { params })
  }
}
